import { markRaw } from 'vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import electionMapSpecial from '@/components/pages/page-election-map-new/election-map-special/election-map-special.vue';
import electionMapTable from '@/components/pages/page-election-map-new/election-map-table/election-map-table.vue';
import electionMapToolbar from '@/components/pages/page-election-map-new/election-map-toolbar/election-map-toolbar.vue';
import overviewMap from '@/components/pages/page-election-map-new/overview-map/overview-map.vue';
import log from '@/logger';
import loaderMixin from '@/mixins/loader';
import {
  ElectionMapChartOverall,
  ElectionMapChartParty,
  ElectionMapChartSenate,
} from '@/utils/chart-models';
import { applyChartTheme } from '@/utils/chart-theme';
import {
  CONTRACTS,
  COLOR_INDEXES,
  PRICE_FACTORS,
  COLOR_MAP,
  getColorForPalletteCandidate,
} from './election-map-constants';

// Moved to ./election-map-constants.js to break circular imports with the
// sibling components; re-exported here for backward compatibility.
export { CONTRACTS, COLOR_INDEXES, PRICE_FACTORS, COLOR_MAP, getColorForPalletteCandidate };

export default {
  mixins: [loaderMixin],
  components: {
    electionMapToolbar,
    electionMapTable,
    electionMapSpecial,
    overviewMap,
  },
  data() {
    return {
      type: 'senate',
      chart: null,
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop']),
    ...mapState('app', ['resolvedTheme']),
    ...mapState('market', [
      'mapStateData',
      'mapOverviewData',
      'mapStateDataSenate',
      'mapOverviewDataSenate',
    ]),
    ChartClass() {
      if (this.type === 'electoral') {
        return ElectionMapChartParty;
      }
      if (this.type === 'senate') {
        return ElectionMapChartSenate;
      }
      return ElectionMapChartOverall;
    },
  },
  watch: {
    type: {
      handler: 'typeHandler',
      immediate: true,
    },
    resolvedTheme() {
      applyChartTheme(this.chart);
    },
  },
  methods: {
    ...mapActions('market', [
      'getMapStateData',
      'getMapOverviewData',
      'getMapOverviewDataSenate',
      'getMapStateDataSenate',
    ]),
    typeHandler() {
      this.loaderAdd();
      if (this.type === 'electoral') {
        this.getMapOverviewData()
          .then(() => this.getMapStateData())
          .then((data) => this.createChart(data))
          .catch((error) => log.error('Request failed.', error))
          .finally(() => this.loaderRemove());
      } else if (this.type === 'senate') {
        this.getMapOverviewDataSenate()
          .then(() => this.getMapStateDataSenate())
          .then((data) => this.createChart(data))
          .catch((error) => log.error('Request failed.', error))
          .finally(() => this.loaderRemove());
      }
    },
    createChart(data) {
      setTimeout(() => {
        this.renderChart(data);
      }, this.ChartClass.renderTimeout());
    },
    renderChart(data) {
      if (!this.$refs.chart) return;
      if (this.chart) {
        this.chart.destroy();
      }
      const group = new this.ChartClass(data);
      this.chart = markRaw(group.draw(this.$refs.chart));
      applyChartTheme(this.chart);
    },
    onToggle() {
      this.type = this.type === 'electoral' ? 'senate' : 'electoral';
    },
  },
  created() {
    if (this.$route.query.map) {
      this.type = this.$route.query.map;
    }
  },
  beforeUnmount() {
    this.chart?.destroy();
  },
};
